import React from 'react';
import { formatDate, todayISO } from '../../utils/dates';

const sinAcentos = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Indicador visual de estado (Vencido/Hoy/Próximo/Completado o Vencida/Pendiente/Parcial/Pagada). */
export const EstadoBadge = ({ estado }) => <span className={`fx-badge fx-badge--${sinAcentos(estado)}`}>{estado}</span>;

/** 'YYYY-MM-DD' → 05/11/2026 (sin desfase de zona horaria). */
export const fechaCorta = formatDate;

/** Texto relativo: Hoy, Mañana, En 3 días, Hace 2 días. */
export const relativo = (dias) => {
  if (dias == null) return '';
  if (dias === 0) return 'Hoy';
  if (dias === 1) return 'Mañana';
  if (dias === -1) return 'Ayer';
  return dias > 0 ? `En ${dias} días` : `Hace ${-dias} días`;
};

export const hoyGT = todayISO;
